export default __webpack_public_path__ + "static/media/helo2_en.88784984.jpg";